import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm } from 'redux-form';
import { components } from '@glowforge/ui-common';

import SubmitActions from 'app/common/components/forms/submit-actions';
import { validateAccountInfo, GeneralAccountFields } from './general-account-fields';
import { validateSetPassword, SetPasswordFields } from './password-fields';
import './accept-invite.less';

const { Markdown } = components;

function validateAcceptInvite(values) {
  const errors = validateAccountInfo(values);
  return validateSetPassword(values, errors);
}

let AcceptInviteForm = props => (
  <form className='AcceptInviteForm' onSubmit={props.handleSubmit}>
    { GeneralAccountFields() }
    { SetPasswordFields() }
    <SubmitActions {...props} submitText={props.submitButton} />
  </form>
);

AcceptInviteForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitButton: PropTypes.string,
};

AcceptInviteForm.defaultProps = {
  submitButton: 'Create Account',
};

// Decorate the form component
AcceptInviteForm = reduxForm({
  form: 'acceptInvite',
  enableReinitialize: true,
  validate: validateAcceptInvite,
})(AcceptInviteForm);


// General Account Form Wrapper with heading
const GeneralAccount = (props) => {
  let sideBarContent;
  if (props.sideBarContent && props.sideBarContent.length > 0) {
    sideBarContent = <Markdown className='ContentColumn' source={props.sideBarContent} />;
  }
  return (
    <div className='AcceptInvite'>
      <div className='content'>
        <h2 className='h2'>{props.inviterName}<br /> {props.title}</h2>
        <div className='columns'>
          <div className='AcceptInviteFormColumn'>
            <h3 className='h3'>{props.formHeader}</h3>
            <AcceptInviteForm {...props} />
          </div>
          { sideBarContent }
        </div>
      </div>
    </div>
  );
};

GeneralAccount.propTypes = {
  inviterName: PropTypes.string.isRequired,
  title: PropTypes.string,
  formHeader: PropTypes.string,
  sideBarContent: PropTypes.string,
};

GeneralAccount.defaultProps = {
  title: 'invited you to print on their Glowforge',
  formHeader: 'Create your account',
  sideBarContent: '',
};


export default GeneralAccount;



// WEBPACK FOOTER //
// ./app/components/settings/accept-invite.jsx